// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class InstrumentVolumeLimitGroup extends PFixFieldSet {
    get instrumentType() {
        return super.GetValue(FieldsFactory.FIELD_TYPE);
    }
    get currentVolumeLimit() {
        return super.GetValue(FieldsFactory.FIELD_CURRENT_VOLUME_LIMIT);
    }
    get relativeVolumeLimit() {
        return super.GetValue(FieldsFactory.FIELD_RELATIVE_VOLUME_LIMIT);
    }
    constructor(pfixFieldSet) {
        super(FieldsFactory.INSTRUMENT_VOLUME_LIMIT_GROUP, null, pfixFieldSet);
    }
}
